// src/redux/reducers/supplierFormReducer.js

import {
  SET_SUPPLIER_FORM_DATA,
  UPDATE_SUPPLIER_FORM_DATA,
  CLEAR_SUPPLIER_FORM_DATA,
  SET_SUPPLIER_EXTRACTED_DATA,
  SET_SUPPLIER_RESOLVED_FIELDS,
  SET_SUPPLIER_LOADING,
  SET_SUPPLIER_LOADING_LABEL,
  SET_SUPPLIER_RESULT,
  SET_SUPPLIER_CURRENT_SECTION,
  SET_SUPPLIER_SHOW_OUTPUT,
  SET_RECORD_EDITING_FIELD,
  SET_RECORD_EDITED_VALUE,
  CLEAR_RECORD_EDITING,
  SET_RECORD_UPDATE_RESULT,
} from "../actions";

// Define the initial state for supplier form data
const initialState = {
  formData: {},
  extractedData: {},
  resolvedFields: [],
  isProcessing: false,
  errors: {},
  currentSectionIndex: 0,
  showOutputScreen: false,
  loading: false,
  loadingLabel: "",
  result: null,
  // Record management state
  editingFields: {},
  editedValues: {},
  recordUpdateResult: null,
};

// The supplierFormReducer handles supplier form data actions
const supplierFormReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SUPPLIER_FORM_DATA:
      return {
        ...state,
        formData: action.payload,
        errors: {},
      };
    
    case UPDATE_SUPPLIER_FORM_DATA:
      return {
        ...state,
        formData: {
          ...state.formData,
          [action.payload.fieldName]: action.payload.value,
        },
        errors: {
          ...state.errors,
          [action.payload.fieldName]: null, // Clear error when field is updated
        },
      };
    
    case SET_SUPPLIER_EXTRACTED_DATA:
      return {
        ...state,
        extractedData: action.payload,
        formData: {
          ...state.formData,
          ...action.payload,
        },
      };
    
    case SET_SUPPLIER_RESOLVED_FIELDS:
      return {
        ...state,
        resolvedFields: action.payload,
      };
    
    case SET_SUPPLIER_LOADING:
      return {
        ...state,
        loading: action.payload,
      };
    
    case SET_SUPPLIER_LOADING_LABEL:
      return {
        ...state,
        loadingLabel: action.payload,
      };
    
    case SET_SUPPLIER_RESULT:
      return {
        ...state,
        result: action.payload,
      };
    
    case SET_SUPPLIER_CURRENT_SECTION:
      return {
        ...state,
        currentSectionIndex: action.payload,
      };
    
    case SET_SUPPLIER_SHOW_OUTPUT:
      return {
        ...state,
        showOutputScreen: action.payload,
      };
    
    case SET_RECORD_EDITING_FIELD:
      return {
        ...state,
        editingFields: {
          ...state.editingFields,
          [action.payload.field]: action.payload.isEditing,
        },
      };
    
    case SET_RECORD_EDITED_VALUE:
      return {
        ...state,
        editedValues: {
          ...state.editedValues,
          [action.payload.field]: action.payload.value,
        },
      };
    
    case CLEAR_RECORD_EDITING:
      return {
        ...state,
        editingFields: {},
        editedValues: {},
      };
    
    case SET_RECORD_UPDATE_RESULT:
      return {
        ...state,
        recordUpdateResult: action.payload,
      };
    
    case CLEAR_SUPPLIER_FORM_DATA:
      return initialState;
    
    default:
      return state;
  }
};

export default supplierFormReducer; 